import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'
import Loading from '../../../../common/component/Loading'

class CognitoUserList extends CognitoUserManagement {
  componentWillMount () {
    this.loadUserList()
  }
  loadUserList () {
    const onSuccess = (cognitoUsers) => {
      let userList = cognitoUsers.map(({ userData, logs }) => {
        const maxActionDateTime = logs.length > 0
          ? logs.reduce((max, log) => log.actionDateTime > max ? log.actionDateTime : max, logs[0].actionDateTime)
          : null;  // logsがない場合はnullを設定

        return {
          ...userData, // ユーザーのデータをそのままコピー
          maxActionDateTime: maxActionDateTime // 最大actionDateTimeを追加
        };
      });
      if (this.props.parentID) {
        userList = cognitoUsers.filter((u) => {
          return u.Attributes.filter((e) => e.Name === 'custom:ParentID')[0].Value === this.props.parentID
        })
      }
      this.setState({
        isLoaded: true,
        userList: userList
      })
    }
    this.getAllUsersLoginInfo(onSuccess)
  }
  formatDateTime(dateTime) {
    if (!dateTime) return '';
    const dateTimeStr = dateTime.toString();
    const year = dateTimeStr.slice(0, 4);
    const month = dateTimeStr.slice(4, 6);
    const day = dateTimeStr.slice(6, 8);
    const hour = dateTimeStr.slice(8, 10);
    const minute = dateTimeStr.slice(10, 12);
    const second = dateTimeStr.slice(12, 14);
    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push('/company_admin/' + this.userRoleUrl + '/add')
        break
      default:
        break
    }
  }
  selected (user, e) {
    this.props.history.push('/company_admin/' + this.userRoleUrl + '/detail/' + user.id)
  }
  renderUserList (userList) {
    if (!userList) {
      return (
        <tr><td colSpan='5' style={{textAlign: 'center'}}>現時点で登録されているデータはございません。</td></tr>
      )
    }
    return userList.map(cognitoUser => {
      const user = {
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username,
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID'),
        maxActionDateTime: this.formatDateTime(cognitoUser.maxActionDateTime),
      }
      return (
        <tr key={user.id} onClick={(e) => this.selected(user, e)}>
          <td>{user.name}</td>
          <td>{user.enabled ? '有効' : '無効'}</td>
          <td>{user.email}</td>
          <td>{this.utc2jst(user.createdDateTime)}</td>
          <td>{this.utc2jst(user.updatedDateTime)}</td>
          <td>{user.maxActionDateTime || ''}</td>
        </tr>
      )
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const userList = this.renderUserList(this.state.userList)
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span8'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報管理<br /><small>こちらから{this.userRoleName}情報を管理できます。</small></h3>
                </header>
              </div>
              <div className='span8'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'>
                    <a rel='tooltip' data-placement='left' title='新規のお知らせを登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                      <i className='icon-plus icon-large' /><br /><span>新規</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-info-sign icon-large' />
              <h5>{this.userRoleName}情報</h5>
            </div>
            <div className='box-content box-table'>
              <table className='table table-hover tablesorter'>
                <thead>
                  <tr>
                    <th>{this.userRoleName}名</th>
                    <th>アカウント有効/無効</th>
                    <th>企業ユーザーメールアドレス</th>
                    <th className='kw-list-date'>作成日時</th>
                    <th className='kw-list-date'>最終更新日時</th>
                    <th className='kw-list-date'>最終ログイン日時</th>
                  </tr>
                </thead>
                <tbody>
                  {userList}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default CognitoUserList



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/abstract/CognitoUserList.js